import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core';
import { MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { INotificationComponent } from '@x/ecommerce-shop/app/core/notification/notification.service';
import { NotificationComponent } from '@x/ecommerce-shop/app/core/notification/notification/notification.component';
import { CloseButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/close-button/close-button.module';
import { NeedHelpModule } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help.module';
import { ShopDialogUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-dialog-ui/shop-dialog-ui.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';

@Component({
  selector: 'x-delivery-context-notification',
  standalone: true,
  imports: [
    ShopDialogUiModule,
    NotificationComponent,
    CloseButtonModule,
    MatBottomSheetModule,
    FaIconComponent,
    MatButton,
    NeedHelpModule,
    UtilsModule,
  ],
  templateUrl: './delivery-context-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-delivery-context-notification' },
})
export class DeliveryContextNotificationComponent
  implements INotificationComponent<DeliveryContextNotificationComponent, any>
{
  bottomSheetRef = inject(MatBottomSheetRef, { optional: true });
  dialogRef = inject(MatDialogRef, { optional: true });

  get shippingMethodContext() {
    return this.shopConfig.features.nextDayDelivery;
  }

  closeNotification(): void {
    this.bottomSheetRef?.dismiss();
    this.dialogRef?.close();
  }

  constructor(@Inject(SHOP_CONFIG) public shopConfig: IShopConfig) {}
}
